import { CroppingStyleProvider, getStdFieldHistory, ICrop, IField, ISoilType, ISubsoilType, IVariety, models, selectMany } from "../omnia"

export interface FieldSetupContext {
    soilTypes: ISoilType[],
    subsoilTypes: ISubsoilType[],
    crops: ICrop[]
}

export function setupFields(fields: IField[], refs: FieldSetupContext, styleProvider: CroppingStyleProvider) {

    for (const f of fields) {
        f.Cropping = f.Cropping || []
    }

    const cropping = selectMany(fields.map(f => f.Cropping))

    omnia.setDates(cropping, ["SowingDate", "HarvestDate", "DestructionDate", "StartDate", "EndDate"], true)

    for (const f of fields) {
        f.Cropping.forEach(c => c.Field = f)
    }

    setupFieldReferences(fields, refs)

    for (const c of cropping) {

        c.Crop = c.Crop || <ICrop>{}
        c.Plans = c.Plans || []
        c.InSeedsPlan = c.Plans.some(c => c.Type == models.PlanType.SeedPlan)
        c.InNutritionPlan = c.Plans.some(c => c.Type == models.PlanType.NutritionPlan || c.Type == models.PlanType.NutritionPlan2024)
        c.InSprayPlan = c.Plans.some(c => c.Type == models.PlanType.SprayPlan)

        c.Style = styleProvider({
            year: c.YearId,
            cropId: c.CropId,
            crop: { style: c.Crop?.Style },
            varietyId: c.VarietyId,
            variety: { style: c.Variety?.Style },
            purpose: c.Market ?? c.Variety?.Market,
            grassManagement: c.GrassManagement,
            grassCuts: c.GrassCuts,
            croppingCropDescr: c.CropDescr
        })

    }

    fields.forEach(setupFieldHistory)

    return fields

}

export function setupFieldHistory(field: IField) {

    const cropping = field.Cropping

    const history = getStdFieldHistory(cropping, { fieldArea: field.CroppingArea, fieldName: field.Name })

    cropping.forEach(c => {

        const h = history.find(h => h.cropping === c) || { prev: [], next: [] }
        const prev = h.prev || []
        const next = h.next || []

        c.PreviousIds = prev.map(c => c.CroppingId)
        c.PreviousCroppings = prev

        c.NextIds = next.map(i => i.CroppingId)
        c.NextCroppings = next

    })

}

function setupFieldReferences(fields: IField[], refs: FieldSetupContext) {

    const { soilTypes, subsoilTypes, crops } = refs

    fields.forEach(f => {

        f.SoilType = soilTypes.find(st => st.SoilTypeId == f.SoilTypeId) || <ISoilType>{
            SoilTypeId: f.SoilTypeId,
            Name: "#" + f.SoilTypeId + "?",
        }

        f.SubsoilType = subsoilTypes.find(st => st.SubsoilTypeId == f.SubsoilTypeId) || <ISubsoilType>{
            SubsoilTypeId: f.SubsoilTypeId,
            Name: "#" + f.SubsoilTypeId + "?",
        }

        f.Cropping.forEach(crp => {

            if (crp.CropId) {

                crp.Crop = crops.find(c => crp.CropId == c.CropId) || <ICrop>{
                    CropId: crp.CropId,
                    Name: "#" + crp.CropId + (crp.CropName ? "(" + crp.CropName + ")" : "") + "?",
                    Varieties: []
                }

                if (crp.Crop && crp.VarietyId) {

                    crp.Variety = crp.Crop.Varieties.find(v => crp.VarietyId == v.CropVarietyId) || <IVariety>{
                        CropVarietyId: crp.VarietyId,
                        Name: "#" + crp.VarietyId + "?"
                    }

                }

            }

        })

    })

}
